import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Fade from 'react-reveal/Fade';

import GlobalSectionBackground from '../../static/img/home_page/global_nia_online_mind_body_fitness.webp';

const styles = theme => ({
  section: {
    width: '100%',
    backgroundImage: `url(${GlobalSectionBackground})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    margin: '0 auto',
  },
  content: {
    width: '100%',
    [theme.breakpoints.up(900)]: {
      width: '900px',
    },
    margin: '0 auto',
    marginBottom: theme.spacing(4),
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  sectionHeader: {
    textAlign: 'center',
    color: 'white',
    margin: theme.spacing(2),
    fontSize: 36,
  },
  sectionText: {
    color: 'white',
    marginBottom: theme.spacing(5),
    fontWeight: 'bold',
    textAlign: 'center',
  },
  action: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    color: 'white',
    border: '1px solid white',
    fontWeight: 'bold',
  },
});

function GlobalSection(props) {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <div className={classes.content}>
        <Fade bottom>
          <Typography className={classes.sectionHeader} color="textSecondary" variant="h3">FIND YOUR GLOBAL FEEL GOOD FITNESS</Typography>
        </Fade>
        <Fade bottom>
          <Typography className={classes.sectionText} color="textSecondary" variant="h6">You can find Nia classes and trainings all over the world. Dance with us in Paris. Sweat with us in Sydney. Heal with us in Helsinki. Meditate with us in Macao.</Typography>
        </Fade>
        <Grid container spacing={3} alignContent="center" justifyContent="space-evenly">
          <Grid item xs={3} className={classes.itemContainer}>
            <Fade bottom>
              <Button href="/finder/class" color="secondary" className={classes.action} variant="outlined">Classes</Button>
            </Fade>
          </Grid>
          <Grid item xs={3} className={classes.itemContainer}>
            <Fade bottom>
              <Button href="/finder/training" color="secondary" className={classes.action} variant="outlined">Trainings</Button>
            </Fade>
          </Grid>
          {/*<Grid item xs={4} className={classes.itemContainer}>
            <Fade bottom>
              <Button href="/finder/event" color="secondary" className={classes.action} variant="outlined">Events</Button>
            </Fade>
          </Grid>*/}
        </Grid>
      </div>
    </div>
  );
}

GlobalSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GlobalSection);
